import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { HTTP } from "../../api/resources";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import NoListEditor from "../Helpers/Utilities/NoListEditor";
import PageBlocking from "./Memberships/PageBlocking";
import { DirectUpload } from '@rails/activestorage';
import PageMemberships from "./Memberships/PageMemberships";

export default function PagesEdit(props) {
  const [page, setPage] = useState(props.page);
  const [saving, setSaving] = useState(false);
  const team = props.team
  const titles = props.titles
  const membersInfo = props.members_info
  const blockedMembers = props.blocked_members
  const [fileUploading, setFileUploading] = useState(false)
  let image = null

  const handleSubmit = () => {
    setSaving(true)
    HTTP.patch(`/pages/${props.page.id}`, {
      page: page
    }).then(response => {
      Alert.show("notice", "Page saved!");
      setPage(response.data);

      setSaving(false);
    }).catch(e => {
      Alert.show("error", "Could not save. Try again or refresh.");
      setSaving(false);
    })
  }

  const hiddenFileInput = React.useRef(null);

  const handleClick = (event) => {
      hiddenFileInput.current.click();
  }

  const handleChange = (event) => {
    Alert.show('notice', 'Uploading image, please wait....')
      const files = event.target.files;
      // upload only the first file
      uploadFile(files[0])
  }

  const uploadFile = (file) => {
    // Check for .jiff extension
    if (file.name.endsWith('.jfif')) {
        Alert.show('error', '.jiff image is not allowed');
        return;
    }
    
    setFileUploading(true)
    const upload = new DirectUpload(file, '/api/v1/direct_uploads');
    upload.create((error, blob) => {
      if (error) {
        // Handle the error
        Alert.show("error", "Could not update. Try again.");
        setFileUploading(false)
      } else {
        setTimeout(() => { setFileUploading(false) }, 5000);
        image = blob
        setPage({...page, banner_image: image.cdn_url})
        Alert.show('notice', 'Image has been added')
      }
    })
  }

  useEffect(() => {
  }, [page.banner_image])

  return (
    <React.Fragment>
        <div className="page-header d-flex align-items-baseline">
            <h4 className="">
                <a href="/pages">
                <i className="fa fa-chevron-left mr-2"></i> Back
                </a>
            </h4>
            <ul className="breadcrumbs">
                <li className="nav-item">
                Pages
                </li>

                <li className="separator">
                <i className="fa fa-arrow-right"></i>
                </li>
                <li className="nav-item">
                {page.title}
                </li>
            </ul>
        </div>

      {!page.public && page.banner_image &&
        <div class="card" style={{height: "200px"}}>
            <div class="row w-100 h-100 margin-auto" style={{margin: "auto"}}>
                <img src={page.banner_image} class="img-fluid w-100 h-100" alt="Responsive image" />
            </div>
        </div>
      }

      <div className="card">
        <div className="card-header flex-header">
          <h4 className="card-title">
            Page Editor
          </h4>

          <div>
            <button onClick={handleSubmit} name="button" className="btn btn-primary">
              {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
              Save
            </button>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-8">
              <div className="form-group">
                <label htmlFor="title">Name</label>
                <input className="form-control" placeholder="New Page" type="text" name="title" id="title"
                  value={page.title}
                  onChange={e => {
                    const val = e.target.value;
                    setPage(page => {
                      return { ...page, title: val }
                    });
                  }}
                />
              </div>
            </div>
            <div className="col-md-4">
            <div className="form-group">
                  <label>{ team.community_title } Status</label>
                  <div>
                      <ToggleSwitch small id="community_status" checked={page.archived}
                          onChange={(checked) => setPage({...page, archived: checked})}
                      />
                      <label htmlFor="community_status">
                          Archive
                      </label>
                  </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-8">
              <div className="form-group">
                <label htmlFor="body">Description</label>
                <NoListEditor value={page.body} returnChange={(value) => setPage({...page, body: value})} />
              </div>
            </div>
            <div className='col-md-4'>
            <div className="form-group">
                  <label htmlFor="profile_image">{`Cover Image`}</label>
                  <div id="profile_image" className="d-flex align-items-center">
                      <button onClick={handleClick} className="btn btn-primary">
                      {fileUploading && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                          Upload Image
                      </button>
                  </div>
                    <div>
                        <small className="text-muted">Optimal Banner Photo Size: 1200px X 421px</small>
                    </div>
                    <input
                        type="file"
                        ref={hiddenFileInput}
                        style={{ display: "none" }}
                        onChange={handleChange}
                    />
                </div>
            </div>
          </div>
        </div>
      </div>

      {/* Community Membership */}
        <PageMemberships
          pageId={page.id}
          allData={props.memberships_data}
          groups={props.member_groups}
          members={props.members}
        />

        <PageBlocking pageId={page.id} allMembers={props.members} blockedMembers={blockedMembers} />

      {/* Accessibility settings */}
      <div className="card">
                  <div className="card-header flex-header">
                      <h4 className="card-title">Accessibility Settings</h4>
                  </div>

                  <div className="card-body">
                      <div className="row">
                          <div className="col-md-6">

                              <div className="form-group">
                                  <div>
                                      <ToggleSwitch small id="donor" checked={page.donor_allowed}
                                          onChange={(checked) => setPage({...page, donor_allowed: checked})}
                                          disabled={page.private}
                                      />
                                      <label htmlFor="donor">
                                          Allow { titles.donor.toLowerCase() } to join
                                      </label>
                                  </div>
                                  <small className="text-muted">
                                      { titles.donor } will not see this { team.community_title.toLowerCase() } if this option is turned off
                                  </small>
                              </div>

                              <div className="form-group">
                                  <div>
                                      <ToggleSwitch small id="user" checked={page.user_allowed}
                                          onChange={(checked) => setPage({...page, user_allowed: checked})}
                                          disabled={page.private}
                                      />
                                      <label htmlFor="user">
                                          Allow users to join
                                      </label>
                                  </div>
                                  <small className="text-muted">
                                      Project managers, sponsorship managers and project co-ordinators will not see
                                      this { team.community_title.toLowerCase() } if this option is turned off
                                  </small>
                              </div>
                          </div>

                          <div className="col-md-6">
                              <div className="form-group">
                                  <div>
                                      <ToggleSwitch small id="access" checked={page.private}
                                          onChange={(checked) => {
                                              setPage({
                                                  ...page, private: checked, beneficiary_allowed: false,
                                                  donor_allowed: false, user_allowed: false
                                              })
                                          }}
                                      />
                                      <label htmlFor="access">
                                          Make this { team.community_title.toLowerCase() } private
                                      </label>
                                  </div>
                                  <small className="text-muted">
                                      Private { team.community_title.toLowerCase() } can only be seen by the manually selected members
                                      while any user can join when made public based on futher settings
                                  </small>
                              </div>

                              <div className="form-group">
                                  <div>
                                      <ToggleSwitch small id="bene" checked={page.beneficiary_allowed}
                                          onChange={(checked) => setPage({...page, beneficiary_allowed: checked})}
                                          disabled={page.private}
                                      />
                                      <label htmlFor="bene">
                                          Allow { titles.beneficiary.toLowerCase() } to join
                                      </label>
                                  </div>
                                  <small className="text-muted">
                                      { titles.beneficiary } will not see this { team.community_title.toLowerCase } if this option is turned off
                                  </small>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              {/* Messaging settings */}
            <div className="card">
                <div className="card-header flex-header">
                    <h4 className="card-title">Messaging Settings</h4>
                </div>

                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <div>
                                    <ToggleSwitch small id="a_o" checked={page.admin_only_messaging}
                                        onChange={(checked) => {
                                            setPage({
                                                ...page, admin_only_messaging: checked, donor_messaging: false,
                                                beneficiary_messaging: false, user_messaging: false
                                            })
                                        }}
                                    />
                                    <label htmlFor="a_o">
                                        Admin only messaging
                                    </label>
                                </div>
                                <small className="text-muted">
                                    If this option is turned on, only the manager or team owner will be able to send
                                    messages, the { team.community_title.toLowerCase() } will operate like a channel
                                </small>
                            </div>

                            <div className="form-group">
                                <div>
                                    <ToggleSwitch small id="d_m" checked={page.donor_messaging}
                                        onChange={(checked) => setPage({...page, donor_messaging: checked})}
                                        disabled={page.admin_only_messaging}
                                    />
                                    <label htmlFor="d_m">
                                        Allow { team.donor_title.toLowerCase() } messaging
                                    </label>
                                </div>
                                <small className="text-muted">
                                    { titles.donor } will not be able to send messages to the community unless this
                                    option is turned on
                                </small>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <div>
                                    <ToggleSwitch small id="u_m" checked={page.user_messaging}
                                        onChange={(checked) => setPage({...page, user_messaging: checked})}
                                        disabled={page.admin_only_messaging}
                                    />
                                    <label htmlFor="u_m">
                                        Allow user messaging
                                    </label>
                                </div>
                                <small className="text-muted">
                                    Project managers, sponsorship managers and project co-ordinators will not be able to
                                    send messages to the community unless this option is turned on
                                </small>
                            </div>

                            <div className="form-group">
                                <div>
                                    <ToggleSwitch small id="b_m" checked={page.beneficiary_messaging}
                                        onChange={(checked) => setPage({...page, beneficiary_messaging: checked})}
                                        disabled={page.admin_only_messaging}
                                    />
                                    <label htmlFor="b_m">
                                        Allow { team.beneficiary_title.toLowerCase() } messaging
                                    </label>
                                </div>
                                <small className="text-muted">
                                    { titles.beneficiary } will not be able to send messages to the community unless this
                                    option is turned on
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </React.Fragment>
  );
}

PagesEdit.propTypes = {
  page: PropTypes.object
};
